import comp from "./ProgressBar";
export default comp;
